import { Data_getInstancevkdckiamkh8 as Data_getInstance } from './adapter/SavePlayerMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePlayerMutationSelections_getInstance2111u0iaqb9bb as SavePlayerMutationSelections_getInstance } from './selections/SavePlayerMutationSelections.mjs';
import { SavePlayerMutation_VariablesAdapter_instance2j730pyqlhj9r as SavePlayerMutation_VariablesAdapter_instance } from './adapter/SavePlayerMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePlayer) {
        this.f6h_1 = savePlayer;
      }
      toString() {
        return 'Data(savePlayer=' + this.f6h_1 + ')';
      }
      hashCode() {
        return this.f6h_1 == null ? 0 : getBooleanHashCode(this.f6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.f6h_1 == other.f6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.g6h_1 = obj(Data_getInstance());
        this.h6h_1 = (new (Builder())('data', Companion_getInstance().n6d_1)).q43(SavePlayerMutationSelections_getInstance().k6h_1).i37();
        this.i6h_1 = '5455c8cf2a3b7e1b46acf575b30dd18c607505908c6096cab88915de6fab9630';
        this.j6h_1 = 'savePlayer';
      }
      q6d() {
        return 'mutation savePlayer($input: SavePlayerInput!) { savePlayer(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePlayerMutationClass;
function SavePlayerMutation() {
  if (SavePlayerMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.l6h_1 = input;
      }
      s6d() {
        return '5455c8cf2a3b7e1b46acf575b30dd18c607505908c6096cab88915de6fab9630';
      }
      operationId() {
        return this.s6d();
      }
      i47() {
        return Companion_getInstance_0().q6d();
      }
      t6d() {
        return 'savePlayer';
      }
      operationName() {
        return this.t6d();
      }
      n46(writer, customScalarAdapters, withDefaultValues) {
        SavePlayerMutation_VariablesAdapter_instance.m6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      m46() {
        return Companion_getInstance_0().g6h_1;
      }
      toString() {
        return 'SavePlayerMutation(input=' + this.l6h_1.toString() + ')';
      }
      hashCode() {
        return this.l6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerMutation()))
          return false;
        if (!this.l6h_1.equals(other.l6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerMutation', VOID, VOID, [Mutation()]);
    SavePlayerMutationClass = $;
  }
  return SavePlayerMutationClass;
}
//region block: exports
export {
  Data as Data1i1ryxd63q3t,
  SavePlayerMutation as SavePlayerMutation13ci6nh8jmmgu,
};
//endregion

//# sourceMappingURL=SavePlayerMutation.mjs.map
